import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const { REACT_APP_API_BASE_URL } = process.env;
const getStripeOauthBaseUrl = () => `${REACT_APP_API_BASE_URL}/pay`;
const getManagementBaseUrl = () => `${getApiBaseUrl()}/mgt`;

const validateStripeCode = (code, groupId) =>
  httpService({
    url: getStripeOauthBaseUrl() + `/verify-stripe-oauth/group/${groupId}`,
    method: 'post',
    data: { code },
  });

const getOnboardingLevels = () =>
  httpService({
    url: getManagementBaseUrl() + `/levels/onboard`,
    method: 'get',
  });

const connectStripeSession = (payload) =>
  httpService({
    url: getManagementBaseUrl() + `/connect/session`,
    method: 'post',
    data: payload,
  });

const createStripeAccount = (payload) =>
  httpService({
    url: getManagementBaseUrl() + `/connect`,
    method: 'post',
    data: payload,
  });

const stripeOnboardingServices = {
  validateStripeCode,
  getOnboardingLevels,
  connectStripeSession,
  createStripeAccount,
};

export default stripeOnboardingServices;
